export const roundToTwoDecimalPoints = (value: number): number => {
  if (!value) {
    return value;
  }
  return Math.round(value * 100) / 100;
};
